import React from "react";
// import styles from "./IncidentForm.module.scss";
import Header from "components/general/Header/Header";
import Typography from "@material-ui/core/Typography";

const IncidentForm = () => {
    return (
        <>
            <Header />
            <Typography variant="h1">Broken/Lost Item Incident</Typography>
            <p>IEEEEEE</p>
        </>
    );
};

export default IncidentForm;
